import { createContext, useContext } from 'react';

export const IsInSearchHeaderContext = createContext(false);

export const useIsInSearchHeader = () => useContext(IsInSearchHeaderContext);
